import Index from '../components/AccessLog/Index.vue'

let routes = {
    path: '/access-log',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '',
            name: 'Logs de Acesso',
            component: Index
        },
    ]
};

export default routes



// WEBPACK FOOTER //
// ./src/router/access-log.js